/**
 * SupplierAccountService
 * Service for Supplier Account entity operations
 * Route: api/supplieraccounts
 */
import { CrudService } from '../base/CrudService';
/**
 * SupplierAccountService
 * Handles supplier account CRUD operations
 */
export class SupplierAccountService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SupplierAccountService.DEFAULT_SERVICE_PATH,
            basePath: SupplierAccountService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get accounts by supplier ID
     * @param supplierId - Supplier ID
     * @returns Array of accounts for the supplier
     */
    async getBySupplier(supplierId) {
        const response = await this.getBySupplierRaw(supplierId);
        return response.data ?? [];
    }
    /**
     * Get accounts by supplier ID (raw)
     * @param supplierId - Supplier ID
     * @returns ResponseData with accounts
     */
    getBySupplierRaw(supplierId) {
        const endpoint = this.getEndpoint('by-supplier', `by-supplier/${supplierId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
SupplierAccountService.DEFAULT_SERVICE_PATH = 'suppliers';
SupplierAccountService.BASE_PATH = 'api/supplieraccounts';
//# sourceMappingURL=SupplierAccountService.js.map